<template>
  <div class="user">
    <UserAvatar
      :user="user"
      size="sm"
      class="user__avatar mr-2" />
    <div>
      <div class="d-flex">
        <div class="user__name mr-2">
          {{ user.name }}
        </div>
        <slot>
          <div class="user__position">
            {{ user.position }}
          </div>
        </slot>
      </div>
      <div class="user__group">
        {{ group }}
      </div>
    </div>
  </div>
</template>

<script>
import UserAvatar from '@/components/parts/UserAvatar.vue'
export default {
  components: {
    UserAvatar
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    group: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.user {
  display: flex;
  align-items: center;

  &__name {
    font-weight: bold;
    font-size: $fs-m;
  }

  &__position {
    font-size: $fs-s;
  }

  &__group {
    font-size: $fs-s;
    color: $l-blue;
  }
}
</style>